export default __webpack_public_path__ + "under_constraction_marker.png";